<i18n
  src="@/locales/views/packing_house/production/palletized/show_package_group.yml"
  lang="yaml"
></i18n>
<i18n src="@/locales/models/package_group.yml" lang="yaml"></i18n>
<i18n src="@/locales/models/package.yml" lang="yaml"></i18n>

<template>
  <go-back-link
    :text="$t('labels.go_back_link')"
    :name="routeName('show_process')"
    :params="{
      packing_house_id: packing_house_id,
      packing_house_process_id: packing_house_process_id,
    }"
  >
  </go-back-link>

  <bread-crumbs :labels="[module_name, packing_house_process?.name]" />

  <div v-if="load_general_data" class="mt-8">
    <div class="panel">
      <div class="panel-header">
        <h3 class="panel-header-title">
          {{ $t("labels.title") }}
        </h3>
      </div>
      <div class="panel-body">
        <div class="space-y-8 divide-y divide-gray-200">
          <div class="grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
            <div class="sm:col-span-3">
              <dt class="label-data">
                {{ $t("model.package_group.pg_code") }}
              </dt>
              <dd class="content-data">
                {{ package_group.pg_code }}
              </dd>
            </div>
            <div class="sm:col-span-3">
              <dt class="label-data">
                {{ $t("model.package_group.grouped_at") }}
              </dt>
              <dd class="content-data">
                {{ dateFormatter(package_group.grouped_at) }}
              </dd>
            </div>
          </div>

          <div class="grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6 pt-4">
            <div class="sm:col-span-6">
              <dt class="label-data">
                {{ $t("model.package_group.comment") }}
              </dt>
              <dd class="content-data">
                {{ package_group.comment }}
              </dd>
            </div>
          </div>

          <div class="grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6 pt-4">
            <div class="sm:col-span-6">
              <dt class="label-data">Empaques</dt>
              <div class="mt-8 flex flex-col">
                <div class="table-first-container">
                  <div class="table-second-container">
                    <div class="table-third-container">
                      <table class="table">
                        <thead class="table-header">
                          <tr>
                            <th scope="col" class="table-header-cell">
                              {{ $t("model.package.week") }}
                            </th>
                            <th scope="col" class="table-header-cell">
                              {{ $t("model.package.registered_at") }}
                            </th>
                            <th scope="col" class="table-header-cell">
                              {{ $t("model.package.producer") }}
                            </th>
                            <th scope="col" class="table-header-cell">
                              {{ $t("model.package.exported_batch") }}
                            </th>
                            <th scope="col" class="table-header-cell">
                              {{ $t("model.package.quantity") }}
                            </th>
                            <th scope="col" class="table-header-cell">
                              {{
                                $t(
                                  "model.package.exporter_process_crop_package"
                                )
                              }}
                            </th>
                            <th scope="col" class="table-header-cell">
                              {{ $t("model.package.exporter_process_brand") }}
                            </th>
                            <th scope="col" class="table-header-cell">
                              {{
                                $t(
                                  "model.package.exporter_process_crop_category"
                                )
                              }}
                            </th>
                          </tr>
                        </thead>
                        <tbody class="table-body">
                          <tr
                            class="table-row"
                            v-for="package_item in package_group.packages"
                            :key="package_item.id"
                          >
                            <td class="table-cell-main">
                              {{ package_item.week }}
                            </td>
                            <td class="table-cell">
                              {{ dateFormatter(package_item.registered_at) }}
                            </td>
                            <td class="table-cell">
                              {{ package_item.entity_name }}
                            </td>
                            <td class="table-cell">
                              {{ package_item.exported_batch.batch_code }}
                            </td>
                            <td class="table-cell">
                              {{ package_item.quantity }}
                            </td>
                            <td class="table-cell">
                              {{
                                package_item.exporter_process_crop_package.label
                              }}
                            </td>
                            <td class="table-cell">
                              {{ package_item.exporter_process_brand.name }}
                            </td>
                            <td class="table-cell">
                              {{
                                package_item.exporter_process_crop_category.name
                              }}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="panel-footer">
        <div class="panel-footer-actions gap-x-2">
          <success-button
            v-if="package_group.container_id == null"
            @click.prevent="updateReady()"
            :label="
              $t(
                package_group.ready_to_container
                  ? 'labels.preparing'
                  : 'labels.ready_to_container'
              )
            "
            :icon="`fa-solid ${
              package_group.ready_to_container ? 'fa-xmark' : 'fa-check'
            }`"
          />
          <destroy-button
            v-if="!proc_button_destroy"
            :disabled_button="false"
            @destroyEvent="destroy"
            :label="$t('labels.destroy_button_label')"
            :title="$t('labels.destroy_button_title')"
            :message="$t('labels.destroy_button_message')"
            :label_confirm="$t('labels.destroy_button_label_confirm')"
          />
          <destroy-button-processing
            v-else
            :label="$t('labels.destroy_button_label')"
          />
          <edit-button
            @click.prevent="goToEditPackageGroup()"
            :label="$t('labels.edit_link')"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Requester from "@/views/packing_house/requesters/production/palletized/show_package_group.js";

export default {
  name: "PHProductionPalletizedShowPackageGroup",
  components: {},
  data() {
    return {
      load_general_data: false,
      packing_house_process: null,
      package_group: null,
      proc_button_destroy: false,
    };
  },
  props: {
    packing_house_id: { required: true },
    packing_house_process_id: { required: true },
    id: { required: true },
  },
  created() {
    this.checkIfAuthenticated().then(() =>
      this.checkIfAuthorized({
        role: this.$route.meta.role,
        permission: this.$route.meta.permission,
        entity: {
          packing_house_id: this.packing_house_id,
        },
      }).then(() => {
        this.fetchPackingHouseProcess();
        this.fetchPackageGroup();
      })
    );
  },
  computed: {},
  methods: {
    fetchPackingHouseProcess: async function () {
      const response = await Requester.fetchPackingHouseProcess(
        this.packing_house_id,
        this.packing_house_process_id
      );

      this.packing_house_process = response.data;
    },

    fetchPackageGroup: async function () {
      const response = await Requester.fetchPackageGroup(
        this.packing_house_id,
        this.id
      );

      this.package_group = response.data;
      this.load_general_data = true;
    },

    updateReady: async function () {
      const response = await Requester.updateReady(
        this.packing_house_id,
        this.id
      );

      if (response.status === 200) {
        this.package_group.ready_to_container =
          response.data.ready_to_container;
      }
    },

    destroy: async function () {
      try {
        let response = await Requester.destroy(this.packing_house_id, this.id);
        this.registerSuccessNotification({
          title: response.data.success_message,
        });
        this.goToShowProcess();
      } catch (error) {
        if (error.response.status == 422) {
          this.loadStandardErrorMessages({
            title: error.response.data.error_title,
            messages: error.response.data.error_messages,
            fields: error.response.data.error_fields,
          });
        }
      }
    },

    goToShowProcess: function () {
      this.$router.push({
        name: this.routeName("show_process"),
        params: {
          packing_house_id: this.packing_house_id,
          packing_house_process_id: this.packing_house_process_id,
        },
      });
    },

    goToEditPackageGroup: function () {
      this.$router.push({
        name: this.routeName("edit_package_group"),
        params: {
          packing_house_id: this.packing_house_id,
          packing_house_process_id: this.packing_house_process_id,
          id: this.id,
        },
      });
    },
  },
};
</script>
